import Vue from 'vue'
import Vuex from 'vuex'
import Fetch from '../fetch/fly'

Vue.use(Vuex)

// 用户信息
const userinfo = localStorage.getItem('userinfo') ? JSON.parse(localStorage.getItem('userinfo')) : {}
// 系统配置
const sysInfo = localStorage.getItem('sysInfo') ? JSON.parse(localStorage.getItem('sysInfo')) : {}
// 面包屑
const breadList = localStorage.getItem('breadList') ? JSON.parse(localStorage.getItem('breadList')) : []

// 激活的权限
const userLimits = localStorage.getItem('userLimits') ? JSON.parse(localStorage.getItem('userLimits')) : {}

// 用来重置state
const getDefaultState = () => {
  return {
    userinfo, // 用户信息
    breadList,
    sysInfo,
    activateVisible: {
      visible1: false, // 激活
      visible2: false, // 激活成功
      visible3: false, // 激活失败
      visible4: false // 申请试用
    },
    userLimits: userLimits // 权限
  }
}

export default new Vuex.Store({
  state: getDefaultState(),
  mutations: {
    // 重置state
    RESETSTATE(state) {
      Object.assign(state, getDefaultState())
    },
    // 设置用户信息
    SET_USERINFO(state, res) {
      state.userinfo = res
    },
    // 设置系统信息
    SET_SYSINFO(state, res) {
      state.sysInfo = res
    },
    // 设置面包屑
    SET_BREADLIST(state, res) {
      state.breadList = res
    },
    // 修改激活弹窗状态
    SET_ACTIVATEVISIBLE(state, { filed, status }) {
      state.activateVisible[filed] = status
    },
    // 修改激活弹窗状态
    SET_USERLIMIT(state, res) {
      state.userLimits = res
    }
  },
  actions: {
    // 重置state
    resetState({ commit }) {
      commit('resetState')
    },
    // 获取用户信息
    async getUserinfo({ commit }) {
      const params = {
        uriCode: 'API004'
      }
      const res = await Fetch(params)
      localStorage.setItem('userinfo', JSON.stringify(res))
      commit('SET_USERINFO', res)
      this.dispatch('getEnvAuth')
    },
    // 获取权限
    async getEnvAuth({ commit }) {
      const params = {
        uriCode: 'API015'
      }
      const res = await Fetch(params)
      localStorage.setItem('userLimits', JSON.stringify(res))
      commit('SET_USERLIMIT', res)
    },
    async getSysInfo({ commit }) {
      localStorage.removeItem('sysInfo')
      const params = {
        uriCode: 'API_PUB001'
      }
      const res = await Fetch(params)
      if (res.value) {
        const info = JSON.parse(decodeURI(res.value))
        localStorage.setItem('sysInfo', JSON.stringify(info))
        commit('SET_SYSINFO', info)
        if (info.favicon) {
          let link = document.querySelector("link[rel*='icon']") || document.createElement('link')
          link.type = 'image/x-icon'
          link.rel = 'shortcut icon'
          link.href = info.favicon
          document.getElementsByTagName('head')[0].appendChild(link)
        }
        if (info.name) {
          document.getElementsByTagName('title')[0].innerHTML = info.name
        }
      }
    },
    // 获取环境列表
    async getEnvList() {
      const params = {
        uriCode: 'API006'
      }
      const res = await Fetch(params)
      return res.list
    }
  },
  modules: {}
})
